var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "terminal-order-index" },
    [
      _c(
        "basic-container",
        [
          _c("TerminalOrderSearch", {
            ref: "searchWrapper",
            attrs: {
              "channel-options": _vm.channelOptions,
              "tenant-options": _vm.tenantOptions,
            },
            on: { search: _vm.handleSearch, export: _vm.handleExport },
          }),
          _c(
            "div",
            { staticClass: "table-container" },
            [
              _c("TerminalOrderTable", {
                attrs: { "table-data": _vm.tableData, loading: _vm.loading },
                on: { refund: _vm.openRefundDialog },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("ElementPagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.page.currentPage,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.page.pageSize,
                  total: _vm.page.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
          _c("TerminalRefundDialog", {
            attrs: {
              visible: _vm.refundVisible,
              "refund-detail": _vm.currentRefund,
            },
            on: {
              "update:visible": function ($event) {
                _vm.refundVisible = $event
              },
              success: _vm.getList,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }